import React, { useState } from 'react';
import {  Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useForm } from 'react-hook-form/dist/index.ie11';
import { Form ,Button} from 'react-bootstrap';
import RequestManager from "../../singletons/RequestManager";





export default function AccountDetails(props){
  console.log(props)
  
 
  const [displaymesg, setDisplaymesg] = useState();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const {register,handleSubmit,errors,setError} = useForm();
  React.useEffect(() => {
  }, []);

  




 async function onSubmit(values) {
    if (values.Account != values.ConfirmAccount){
        setDisplaymesg("Account Number does not match confirm account");
        return;
    }
    if (values.Account){
        if (values.AccountName == '' || values.AccountName == undefined){
        setDisplaymesg("Please enter a valid Account Name");
        return;
        }
        if (values.ifsccode == '' || values.ifsccode == undefined){
            setDisplaymesg("Please enter a valid IFSC CODE");
            return;
        }
    
    }
    if (values.GSTNO && values.GSTNO.length != 15 &&  values.GSTNO.length > 0){
        setDisplaymesg("Please enter a valid GST Number");
        return;
    }

    let requestManager = new RequestManager();
    let params;
    
    
  
      params ={
      input: {
        id: props.store.id,
        accountNo: values.Account,
        accountName:values.AccountName,
        ifsccode:values.ifsccode,
        gstNo:values.GSTNO
        }
      }  
    

   
  let response =await requestManager.getResponseFromPredefinedQuery(
      "updateStoreAccountDetails",
      params
  );

    if (response.error === null) {
      setDisplaymesg("Succesfully added")
      window.location.reload(false);
    }else
    {
      setDisplaymesg("Somthing went wrong, please try again")
    }
   
}
 
  return (
    <div>
      <Button style={{backgroundColor:"#ff5000", color:"white", width:'100%'}} onClick={toggle}>Account Edit</Button>  
      <Modal isOpen={modal} toggle={toggle} className="">
      {displaymesg &&
     <div className="alert alert-success">
     <strong>{displaymesg}!</strong> 
     </div>
           }
        <ModalHeader toggle={toggle}>Store Account Details</ModalHeader>
        <ModalBody>

              {errors.AccountName && <p className="alert alert-danger aswm" >{errors.AccountName.message}</p>}
              {errors.Account && <p className="alert alert-danger aswm" >{errors.Account.message}</p>}
              {errors.ConfirmAccount && <p className="alert alert-danger aswm" >{errors.EndTime.message}</p>}
              {/*errors.DeliveryDuration && <p className="alert alert-danger aswm" >{errors.DeliveryDuration.message}</p>*/}
              {errors.ifsccode && <p className="alert alert-danger aswm" >{errors.ifsccode.message}</p>}

        <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Control type="text" name="storeId" hidden id="storeId" defaultValue={props.store.id}   ref={register} />

  <Form.Group >
    <Form.Label >Account Name</Form.Label>
    <Form.Control type="text" name="AccountName" id="AccountName" defaultValue={props.store.accountName}  ref={register} />
  </Form.Group>         
  <Form.Group >
    <Form.Label >AccountNo</Form.Label>
    <Form.Control type="text" name="Account" id="Account" defaultValue={props.store.accountNo} ref={register} />
  </Form.Group>

  <Form.Group >
    <Form.Label >Confirm AccountNo</Form.Label>
    <Form.Control type="text" name="ConfirmAccount" id="ConfirmAccount"  defaultValue={props.store.accountNo}  ref={register} />
  </Form.Group>
  <Form.Group >
    <Form.Label >IFSC CODE</Form.Label>
    <Form.Control type="text" name="ifsccode" id="ifsccode"  defaultValue={props.store.ifsccode}  ref={register} />
  </Form.Group>
  <Form.Group >
    <Form.Label >GST Number</Form.Label>
    <Form.Control type="text" name="GSTNO" id="GSTNO"  defaultValue={props.store.gstNo}  ref={register} />
  </Form.Group>
  
  
  <ModalFooter>
  <Button type="submit" style={{background:"green"}} color="primary">Submit</Button>{' '}
  <Button color="secondary"  style={{background:"red"}} onClick={toggle}>Cancel</Button>
</ModalFooter>
</Form>
</ModalBody>
</Modal>
    </div>
  );
}









// WEBPACK FOOTER //
// ./src/components/AccountDetails/AccountDetails.js